import { render, staticRenderFns } from "./importPdfForm.vue?vue&type=template&id=3b982080&scoped=true&"
import script from "./importPdfForm.vue?vue&type=script&lang=js&"
export * from "./importPdfForm.vue?vue&type=script&lang=js&"
import style0 from "./importPdfForm.vue?vue&type=style&index=0&id=3b982080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b982080",
  null
  
)

export default component.exports